import React from 'react';
import { Input } from '@rneui/themed';

export const FormInput = React.forwardRef((props, ref)  => 
{
    const { placeholderStyle, style, value, ...rest } = props;
    
    return (
        <Input {...rest} ref={ref} inputStyle={!value ? [style, placeholderStyle] : style} {...props} />
    );
});
